"use strict";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
var __read = this && this.__read || function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
    r,
    ar = [],
    e;
  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }
  return ar;
};
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RadioInputGroup = exports.RadioInput = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var Box_1 = require("../../../components/Box");
var Grid_1 = require("../../../components/Grid");
var react_1 = require("react");
var react_hook_form_1 = require("react-hook-form");
var CJFormContext_1 = require("../CJFormContext");
var util_1 = require("../util");
var classnames_1 = __importDefault(require("classnames"));
var RadioInput = function (props) {
  var control = (0, react_1.useContext)(CJFormContext_1.CJFormContext).control;
  var _a = __read((0, util_1.extractRegister)(props), 2),
    _b = _a[0],
    registerProps = _a[1],
    name = _b.name,
    className = _b.className,
    restProps = __rest(_b, ["name", "className"]);
  return (0, jsx_runtime_1.jsx)(react_hook_form_1.Controller, {
    name: name,
    control: control,
    rules: registerProps,
    render: function (_a) {
      var field = _a.field;
      return (0, jsx_runtime_1.jsx)("input", __assign({}, restProps, {
        type: "radio",
        disabled: registerProps.disabled || restProps.readOnly,
        className: (0, classnames_1.default)("vsx-cjform-radio-input", className),
        checked: field.value === registerProps.value,
        onClick: function () {
          field.onChange(registerProps.value);
          field.onBlur();
        },
        readOnly: true
      }));
    }
  });
};
exports.RadioInput = RadioInput;
var RadioInputGroup = function (props) {
  var watch = (0, react_1.useContext)(CJFormContext_1.CJFormContext).watch;
  var _a = __read((0, util_1.extractRegister)(props), 2),
    _b = _a[0],
    registerProps = _a[1],
    options = _b.options,
    gap = _b.gap,
    _c = _b.direction,
    direction = _c === void 0 ? "row" : _c,
    name = _b.name,
    readOnly = _b.readOnly,
    boxProps = __rest(_b, ["options", "gap", "direction", "name", "readOnly"]);
  return (0, jsx_runtime_1.jsx)(Box_1.Box, __assign({
    direction: direction,
    gap: (gap !== null && gap !== void 0 ? gap : direction === "row") ? "large" : "medium"
  }, boxProps, {
    children: options.map(function (_a, idx) {
      var label = _a.label,
        value = _a.value,
        details = _a.details,
        expandContent = _a.expandContent;
      return (0, jsx_runtime_1.jsxs)(react_1.Fragment, {
        children: [(0, jsx_runtime_1.jsxs)(Grid_1.Grid, __assign({
          gap: "small",
          align: "start",
          columns: "auto 1fr"
        }, {
          children: [(0, jsx_runtime_1.jsx)(exports.RadioInput, __assign({
            style: {
              marginRight: "2px"
            },
            id: "".concat(name, "-").concat(idx),
            name: name,
            value: value
          }, registerProps, {
            disabled: registerProps.disabled || readOnly
          })), (0, jsx_runtime_1.jsx)("label", __assign({
            htmlFor: "".concat(name, "-").concat(idx)
          }, {
            children: label
          })), (0, jsx_runtime_1.jsx)(OptionDetails, {
            details: details
          })]
        })), (0, jsx_runtime_1.jsx)(OptionExpand, {
          content: expandContent,
          expanded: watch(name) === value
        })]
      }, "".concat(name, "-").concat(idx));
    })
  }));
};
exports.RadioInputGroup = RadioInputGroup;
var OptionDetails = function (_a) {
  var details = _a.details;
  var shouldShow = !!details;
  return shouldShow ? (0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, {
    children: [(0, jsx_runtime_1.jsx)("span", {}), (0, jsx_runtime_1.jsx)("span", __assign({
      className: "vsx-cjform-field-help"
    }, {
      children: details
    }))]
  }) : null;
};
var OptionExpand = function (_a) {
  var content = _a.content,
    expanded = _a.expanded;
  var shouldShow = expanded && !!content;
  return shouldShow ? (0, jsx_runtime_1.jsx)("div", __assign({
    className: "vsx-cjform-radio-input-group-expand"
  }, {
    children: content
  })) : null;
};